import React, {useEffect, useMemo, useState} from "react";
import Box from "@mui/material/Box";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";

const BalanceSheetTable = ({
                               data,
                               tableOptions,
                               tableOptionsHandle,
                               baseCurrency,
                               alternativeCurrency,
                               selectCurrency,
                               globalFilter,
                               handleSearchQuery,
                               filteredData,
                               columnsFilter,
                           }) => {
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const columns = useMemo(() => {

        const baseColumns = [
            {
                id: 'nameMaterial',
                header: `Наименование`,
                accessorKey: 'nameMaterial',
                size: 3,
                maxSize: 3,
            },
            {
                id: 'unit',
                header: `Ед. изм.`,
                accessorKey: 'unit',
                size: 3,
                maxSize: 3,
            },
            {
                id: 'startQuantity',
                header: `Количество на начало периода`,
                accessorKey: 'startQuantity',
                minSize: 250,
                Cell: ({row}) => `${row.original.startQuantity?.toFixed(3)}`,
            },
            {
                id: 'arrivalQuantity',
                header: `Количество прихода`,
                accessorKey: 'arrivalQuantity',
                minSize: 250,
                Cell: ({row}) => `${row.original.arrivalQuantity?.toFixed(3)}`,
            },
            {
                id: 'issuanceQuantity',
                header: `Количество расхода`,
                accessorKey: 'issuanceQuantity',
                minSize: 250,
                Cell: ({row}) => `${row.original.issuanceQuantity?.toFixed(3)}`,
            },
            {
                id: 'endQuantity',
                header: `Количество на конец периода`,
                accessorKey: 'endQuantity',
                minSize: 250,
                Cell: ({row}) => `${row.original.endQuantity?.toFixed(3)}`,
            },
            {
                id: 'startAmountBasePrice',
                header: `Сумма на начало периода в ${baseCurrency}`,
                accessorKey: 'startAmountBasePrice',
                minSize: 250,
                Cell: ({row}) => row.original.startAmountBasePrice?.toFixed(3),
            },
            {
                id: 'arrivalAmountBasePrice',
                header: `Сумма прихода в ${baseCurrency}`,
                accessorKey: 'arrivalAmountBasePrice',
                minSize: 250,
                Cell: ({row}) => row.original.arrivalAmountBasePrice?.toFixed(3),
            },
            {
                id: 'issuanceAmountBasePrice',
                header: `Сумма расхода в ${baseCurrency}`,
                accessorKey: 'issuanceAmountBasePrice',
                minSize: 250,
                Cell: ({row}) => row.original.issuanceAmountBasePrice?.toFixed(3),
            },
            {
                id: 'endAmountBasePrice',
                header: `Сумма на конец периода в ${baseCurrency}`,
                accessorKey: 'endAmountBasePrice',
                minSize: 250,
                Cell: ({row}) => row.original.endAmountBasePrice?.toFixed(3),
            },
            {
                id: 'startAmountAlternativePrice',
                header: `Сумма на начало периода в ${alternativeCurrency}`,
                accessorKey: 'startAmountAlternativePrice',
                minSize: 250,
                Cell: ({row}) => row.original.startAmountAlternativePrice?.toFixed(3),
            },
            {
                id: 'arrivalAmountAlternativePrice',
                header: `Сумма прихода в ${alternativeCurrency}`,
                accessorKey: 'arrivalAmountAlternativePrice',
                minSize: 250,
                Cell: ({row}) => row.original.arrivalAmountAlternativePrice?.toFixed(3),
            },
            {
                id: 'issuanceAmountAlternativePrice',
                header: `Сумма расхода в ${alternativeCurrency}`,
                accessorKey: 'issuanceAmountAlternativePrice',
                minSize: 250,
                Cell: ({row}) => row.original.issuanceAmountAlternativePrice?.toFixed(3),
            },
            {
                id: 'endAmountAlternativePrice',
                header: `Сумма на конец периода в ${alternativeCurrency}`,
                accessorKey: 'endAmountAlternativePrice',
                minSize: 250,
                Cell: ({row}) => row.original.endAmountAlternativePrice?.toFixed(3),
            },
        ];

        return baseColumns;

    }, [data, baseCurrency, alternativeCurrency, filteredData]);


    return (
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    maxHeight: `calc(100vh - 550px)`,
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={filteredData}
            initialState={{
                isFullScreen: false,
                density: "compact",
                pagination: {pageIndex: 0, pageSize: 100},
            }}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            state={{
                columnVisibility: {
                    id: false,
                    startAmountBasePrice: selectCurrency === 1,
                    arrivalAmountBasePrice: selectCurrency === 1,
                    issuanceAmountBasePrice: selectCurrency === 1,
                    endAmountBasePrice: selectCurrency === 1,
                    startAmountAlternativePrice: selectCurrency === 2,
                    arrivalAmountAlternativePrice: selectCurrency === 2,
                    issuanceAmountAlternativePrice: selectCurrency === 2,
                    endAmountAlternativePrice: selectCurrency === 2,
                },
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                showGlobalFilter: true,
                pagination: tableOptions,
            }}
            manualFiltering={true}
            rowCount={tableOptions.totalElements}
            localization={MRT_Localization_RU}
            enableRowActions={false}
            enableToolbarInternalActions={false}
            enableGrouping={true}
        />
    );
}
export default BalanceSheetTable